export default "__VITE_ASSET__DIkzkXZZ__"